import { twMerge } from 'tailwind-merge';
import { BLOBS, classes } from './utils';

// Full-bleed animated background: soft base gradient with slowly warping,
// blurred color "blobs". Position a stacking-context parent (`relative`) around
// it and give foreground content `relative z-10` so it paints above.
export default function BackgroundBlobs() {
  return (
    <div aria-hidden className={classes.background}>
      {BLOBS.map(([blobClass, blobStyle], i) => (
        <div
          key={i}
          style={blobStyle}
          className={twMerge(classes.blob, blobClass)}
        />
      ))}
    </div>
  );
}
